import React from 'react'
import GreetingCard from '../components/GreetingCard'
import { Line } from 'react-chartjs-2';
import SaleCom from '../ui/comp/SaleCom';
import Container from '../ui/comp/Container';
import Table from '../ui/Table/Table';
import Thead from '../ui/Table/Thead';
import Td from '../ui/Table/Td';
import Tbody from '../ui/Table/Tbody';
import FormatCurrency from '../utils/FormatCurrency';
import Status from '../ui/Table/Status';
import Select from '../ui/comp/Select';
import { useUser } from '../hooks/useUser';
import { useSalesSummary } from '../hooks/useSalesSummary';
import { useOrders } from '../hooks/useOrders';
import NoContent from '../components/NoContent';
import { orderStatus } from '../utils/config';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Axios } from '../utils/Axios';

function Home() {

    const { data: user } = useUser();

    const { data: sales } = useSalesSummary();

    const { data: orders } = useOrders()

    const queryClient = useQueryClient()


    // update status

    const { mutate } = useMutation({
        mutationFn: async (formData) => {
            return Axios.post('/order/status', formData)
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['orders'])
        }
    })

    const handleStatus = (order_id, status) => {
        mutate({ order_id, status })
    }


    // Get best selling

    const { data: bestselling, isPending } = useQuery({
        queryKey: ['bestselling'],
        queryFn: async () => {
            const res = await Axios.get('/info/best-selling');
            return res?.data;
        }
    })


    return (
        <div className='w-full relative'>
            {/* Welcome Message */}
            <GreetingCard fullname={`${user?.firstname} ${user?.lastname}`} />
            {/* <p>{user?.firstname}</p> */}
            {/* Sales */}
            <div className="w-full grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 mt-7 gap-3">
                <SaleCom title={"Today Orders"} amount={sales?.today} />
                <SaleCom title={"Yesterday Orders"} color='blue' amount={sales?.yesterday} />
                <SaleCom title={"This Month"} color='purple' amount={sales?.thismonth} />
                <SaleCom title={"Last Month"} color="pink" amount={sales?.lastmonth} />
                <SaleCom title={"All-Time Sales"} color="dark" amount={sales?.alltime} />
            </div>


            {/* Sales activity and oder details */}
            <div className="flex flex-col gap-3 lg:flex-row mt-8 w-full">
                {/* Sales One  */}
                <div className="w-full lg:w-8/12">
                    <Container title={"Perfomance"}>
                        <div className="mt-2">
                            <Line
                                data={{
                                    labels: ["Mon", "Tue", "Wed", "Thu", "Fri"],
                                    datasets: [
                                        {
                                            label: false,
                                            data: [2, 4, 5, 1, 4],
                                            tension: 0.5,
                                            fill: false,
                                            borderColor: "#3b7cff",
                                            pointBackgroundColor: "#3b7cff",
                                            pointRadius: 4,
                                            pointHoverRadius: 5,
                                        },
                                        {
                                            label: false,
                                            data: [4, 5, 6, 2, 3],
                                            tension: 0.5,
                                            fill: false,
                                            borderColor: "#e38a5b",
                                            pointBackgroundColor: "#e38a5b",
                                            pointRadius: 4,
                                            pointHoverRadius: 5,
                                            backgroundColor: "red"
                                        }
                                    ]
                                }}

                                options={{
                                    plugins: {
                                        legend: { display: false }
                                    },
                                    scales: {

                                        y: { display: false },
                                        x: {
                                            display: true,
                                            grid: {
                                                color: "#f2f0f0"
                                            }
                                        }
                                    }
                                }}
                            />
                        </div>
                    </Container>
                </div>


                {/* 2 */}
                <div className="w-full lg:w-4/12">
                    <Container title={"Best Selling"}>
                        <table className="w-full mt-2">
                            <thead>
                                <tr className='border-b'>
                                    <td className='text-sm font-medium pb-3'>Date</td>
                                    <td className='text-sm text-right font-medium pb-2'>Amount</td>
                                </tr>
                            </thead>
                            <tbody>
                            </tbody>
                        </table>
                    </Container>
                </div>

            </div>


            {/* Recent Orders */}
            <div className="w-full relative mt-10">
                <Container title={"Recent Orders"}>
                    {orders && orders?.length ? (
                        <Table>
                            <Thead>
                                <tr>
                                    <Td>Invoice No</Td>
                                    <Td>Order Date</Td>
                                    <Td>Customer Name</Td>
                                    <Td>Amount</Td>
                                    <Td>Method</Td>
                                    <Td>Payment Status</Td>
                                    <Td>Status</Td>
                                    <Td>Actions</Td>
                                </tr>
                            </Thead>

                            <Tbody>
                                {orders?.map((order, i) => (
                                    <tr key={i}>
                                        <Td>{order?.orderNumber}</Td>
                                        <Td>
                                            {new Date(order?.iat).toLocaleString('en-US',
                                                {
                                                    month: 'short', day: '2-digit', year: 'numeric',
                                                })}
                                        </Td>
                                        <Td>{`${order?.User?.firstname} ${order?.User?.lastname}`}</Td>
                                        <Td><FormatCurrency amount={order?.total} /></Td>
                                        <Td>{order?.payment_mode}</Td>
                                        <Td>{order?.payment_status}</Td>
                                        <Td><Status status={order?.status} /></Td>
                                        <Td>
                                            <Select value={order?.status} onChange={(e) => handleStatus(order?.id, e.target?.value)}>
                                                {orderStatus.map((item, i) => (
                                                    <option value={`${item}`}>{item}</option>
                                                ))}
                                            </Select>
                                        </Td>
                                    </tr>
                                ))}
                            </Tbody>
                        </Table>
                    ) : <NoContent />}
                </Container>
            </div>
        </div>
    )
}

export default Home